import * as React from 'react';
import {Provider} from 'react-redux';
import '@pluto-tv/assemble/dist/style.css';
import '@paramount-streaming/assemble-ui-theme-provider';
import '@paramount-streaming/assemble-ui-theme-paramount';
import '@paramount-streaming/assemble-ui-theme-pluto';
import '@paramount-streaming/assemble-blocks-cc-header';
import {getThemeConfig} from 'utils/commandCenterThemeUtils';

import Layout from 'app/layout/Main';

import {store} from './store';
import './App.css';

export default (): JSX.Element => {
  const {theme, variant} = React.useMemo(() => getThemeConfig(), []);

  return (
    <Provider store={store}>
      <a-theme-provider theme={theme} variant={variant}>
        <Layout />
      </a-theme-provider>
    </Provider>
  );
};
